<template>
  <div class="home content-continer" :style="{minHeight:minheight + 'px'}">
    <!-- 最上面项目详情 -->
    <div class="base-content items">
      <div style="margin-bottom:30px;">
        <a class="list-name">{{projectlists.projectName}}</a>
      </div>
      <ul class="list-msg">
        <li>
          <p>CRC人数</p>
          <!-- <p>{{projectlists.list.length?projectlists.list.length:'无'}}</p> -->
          <p>{{projectlists.crcNum?projectlists.crcNum:'无'}}</p>
        </li>
        <li>
          <p>专业名称</p>
          <p>{{projectlists.specialityName?projectlists.specialityName:'无'}}</p>
        </li>
        <li>
          <p>负责人</p>
          <p>{{projectlists.managerName?projectlists.managerName:'无'}}</p>
        </li>
        <li>
          <p>项目类型</p>
          <p>{{projectlists.phaseDesc?projectlists.phaseDesc:'无'}}</p>
        </li>
        <li>
          <p>项目开始时间</p>
          <p>{{projectlists.startDate?projectlists.startDate:'无'}}</p>
        </li>
        <li>
          <p>申办方</p>
          <p>{{projectlists.sponsorName?projectlists.sponsorName:'无'}}</p>
        </li>
        <li>
          <!-- <p>公司名称</p> -->
          <!-- <p>{{projectlists.smoName?projectlists.smoName:'无'}}</p> -->
          <p>医院名称</p>
          <p>{{projectlists.hospitalName?projectlists.hospitalName:'无'}}</p>
        </li>
        <!-- <li>
          <p>公司区域</p>
          <p>{{projectlists.smoProvince?projectlists.smoProvince:'无'}}</p>
        </li>-->
      </ul>
      <p class="remarks">{{projectlists.projectDesc?projectlists.projectDesc:'无'}}</p>
    </div>
    <!-- 人员列表 -->
    <div class="continer-title base-content">
      <div class="blue">CRC人员列表</div>
    </div>
    <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
      <div class="base-content person-list" v-for="(item,index) in projectlists.list" :key="index">
        <ul class="list-msg">
          <li>
            <!-- <el-checkbox :label="item.projectExpId">&nbsp;</el-checkbox> -->
          </li>
          <li class="img-src">
            <img :src="imgurl+item.headImg" />
          </li>
          <li>
            <div class="person-list-title">
              <div class="person-name">{{item.name}}</div>
              <div class="goodAts" v-if="item.goodAts!=''">
                <span v-for="(items,i) in item.goodAts" :key="i">{{items}}</span>
              </div>
            </div>
            <ul>
              <li>
                <p>项目经历</p>
                <p>{{item.projectName?item.projectName:'无'}}</p>
              </li>
              <li>
                <p>学校</p>
                <p>{{item.schoolName?item.schoolName:'无'}}</p>
              </li>
              <li>
                <p>学历</p>
                <p>{{item.eduLevel?item.eduLevel:'无'}}</p>
              </li>
              <li>
                <p>专业</p>
                <p>{{item.major?item.major:'无'}}</p>
              </li>
              <li>
                <p>备案时间</p>
                <p>{{item.beianTime?item.beianTime:'无'}}</p>
              </li>
            </ul>
          </li>
          <li class="msg-modal blue">
            <a @click="previewMsg(item.id)">查看资料</a>
          </li>
        </ul>
        <img src="../assets/hospital-img/s-no-j.png" v-if="item.delegateState==2" class="d" />
        <img src="../assets/hospital-img/s-y-j.png" v-if="item.delegateState==3" class="d" />
        <img src="../assets/hospital-img/yituihui.png" v-if="item.delegateState==4" class="d" />
      </div>
    </el-checkbox-group>
    <div class="center" style="margin-top:50px;" v-if="projectlists.list<=0">暂无数据</div>
    <!-- 查看详情弹出框 -->
    <div class="preview-modal" v-if="peviewstatus">
      <Preview @peviewstatus="closePeview" :childid="childid"></Preview>
    </div>
  </div>
</template>

<script>
import { projectpersonlist } from "@/request/api";
import { crcBatch } from "@/request/api";
import Preview from "../components/preview";
import Cookies from "js-cookie";
export default {
  name: "home",
  components: {
    Preview: Preview
  },
  data() {
    return {
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: true,
      checkedGameId: [],
      projectid: "",
      projectlists: "",
      imgurl: this.Common.imgurl,
      peviewstatus: false,
      childid: "",
      minheight: this.Common.minheight
    };
  },
  methods: {
    handleCheckAllChange(val) {
      // 若val为真返回cityoptions,否则返回[]
      this.checkedCities = val ? this.checkedGameId : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.checkedGameId.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.checkedGameId.length;
    },
    // 查看资料
    previewMsg(id) {
      this.childid = id;
      this.peviewstatus = true;
    },
    closePeview(data) {
      this.peviewstatus = data;
    },
    //crc人员接收
    Batch(status) {
      let expids = this.checkedCities.join(",");
      let data = {
        flag: status,
        projectExpIds: expids,
        userId: Cookies.get("userid")
      };
      crcBatch(data)
        .then(res => {
          console.log(res.data.data);
          this.$message({
            message: "接收成功",
            type: "success"
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    // crc人员列表
    projectpersonlist(this.projectid)
      .then(res => {
        this.projectlists = res.data.data;
        console.log("终极无敌测试dabug~this.projectlists~", this.projectlists);
        for (let i = 0; i < this.projectlists.list.length; i++) {
          this.checkedGameId.push(this.projectlists.list[i].projectExpId);
          // this.multipleSelection = this.checkedGameId
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  created() {
    // 获取项目id
    this.projectid = this.$route.params.id;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.items {
  margin-top: 20px;
  margin-bottom: 20px;
}

.items .list-name {
  font-size: 18px;
  color: #4d4d4d;
}

.items li {
  display: inline-block;
  margin-right: 30px;
}

.item li:last-child {
  margin-right: 0px;
}

.list-msg li p:first-child {
  color: #999999;
  /* font-weight:bold; */
  font-size: 14px;
}

.list-msg li p:last-child {
  color: #666666;
  margin-top: 10px;
  /* font-weight:bold; */
}

.remarks {
  width: 100%;
  /* height: 40px; */
  line-height: 40px;
  background: rgba(245, 245, 245, 1);
  color: #999999;
  font-size: 14px;
  margin-top: 26px;
  padding-left: 5px;
}

.msg-modal a {
  cursor: pointer;
}

.person-list {
  position: relative;
}

.person-list .msg-modal {
  line-height: 140px;
}

.d {
  position: absolute;
  top: 0px;
  right: 0px;
}
</style>


// WEBPACK FOOTER //
// src/hospital/items.vue